import { useNavigate } from "@remix-run/react";
import { ArrowRight } from "lucide-react";
import { Button } from "~/components/ui/button";

export default function UseCaseSection1() {
  const navigate = useNavigate();

  return (
    <section className="relative flex w-full sm:h-[575px]">
      <div className="container flex flex-col items-center gap-12 sm:items-start sm:justify-center">
        <div className="flex max-w-[450px] flex-col gap-8 sm:w-1/2 sm:pr-12">
          <div className="flex flex-col gap-2">
            <h2 className="font-recursive text-4xl font-bold">
              Data entry that's as fast as Excel
            </h2>
            <p className="text-pretty">
              Speed up data entry with an intuitive, spreadsheet-style interface
              right within your Knack app. Update data in-bulk quickly and
              effortlessly.
            </p>
          </div>
          <Button
            className="h-fit w-fit px-8 py-3 text-lg font-semibold leading-normal"
            onClick={() => navigate("/login?try")}
          >
            Try now <ArrowRight className="ml-1 h-6 w-6" />
          </Button>
        </div>
        <img
          src="https://utfs.io/f/dcYEW17H8PtSsGIXtSe7QI3aSwChzRxNmEVPUlBdqDobun9p"
          alt=""
          className="relative top-0 block h-full w-full rounded bg-emerald-400 sm:hidden"
        />
        <img
          src="https://utfs.io/f/dcYEW17H8PtSBFC3nureboAFONduKWgTzvEkHcalXVU3s6SJ"
          alt=""
          className="relative right-0 top-0 hidden h-[540px] w-full rounded bg-emerald-400 sm:absolute sm:right-0 sm:top-0 sm:block sm:min-h-[540px] sm:w-1/2 sm:rounded-r-none sm:pl-8 sm:pr-0"
        />
      </div>
    </section>
  );
}
